export default __webpack_public_path__ + "static/media/capture.99889f18.jpg";